<template>
  <div class="container">
    <b-row class="mt-3">
      <b-col md="4" class="">
        <b-card-group deck>
          <b-card no-body class="heading-myaccount">
            <template #header>
              <div class="d-flex align-items-center">
                <router-link button :to="`/my-order?profile=My Orders`">
                  <b-icon icon="arrow-left-short"></b-icon>
                </router-link>
                <span class="ml-2">Need Help</span>
              </div>
            </template>
            <b-list-group flush>
              <router-link
                class="list-group-item"
                :to="{
                  path: '/faq',
                  query: {
                    needHelp: 'FAQ',
                    orderNumber: this.orderNumber,
                  },
                }"
              >
                <b-icon-question-circle-fill
                  class="mr-2"
                ></b-icon-question-circle-fill>
                {{ $t("accountDetails.faq") }}
              </router-link>
              <router-link
                class="list-group-item"
                :to="{
                  path: '/Contact',
                  query: {
                    needHelp: 'Contact US',
                    orderNumber: this.orderNumber,
                  },
                }"
              >
                <b-icon-envelope-fill class="mr-2"></b-icon-envelope-fill>
                {{ $t("contactUs.title") }}
              </router-link>
              <router-link
                class="list-group-item"
                :to="{
                  path: '/terms_conditions',
                  query: {
                    needHelp: 'Terms & Conditions',
                    orderNumber: this.orderNumber,
                  },
                }"
              >
                <b-icon-key-fill class="mr-2"></b-icon-key-fill>
                Terms & Condition
              </router-link>
              <router-link
                class="list-group-item"
                :to="{
                  path: '/privacy-policy',
                  query: {
                    needHelp: 'Privacy Policy',
                    orderNumber: this.orderNumber,
                  },
                }"
              >
                <b-icon-shield-lock-fill class="mr-2"></b-icon-shield-lock-fill>
                Privacy Policy
              </router-link>
              <router-link
                class="list-group-item"
                :to="{
                  path: '/support-ticket',
                  query: {
                    needHelp: 'Support Ticket',
                    orderNumber: this.orderNumber,
                  },
                }"
              >
                <b-icon-text-indent-left class="mr-2"></b-icon-text-indent-left>
                Support Ticket
              </router-link>
            </b-list-group>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col md="8">
        <div class="profile-maindv">
          <h4><b>Store Details</b></h4>
          <div class="">
            <div
              class="seller-main-info d-flex align-items-center flex-wrap flex-md-nowrap mb-2"
            >
              <template v-if="sellerInfo?.organization?.logo?.url">
                <b-img
                  :src="sellerInfo.organization.logo.url"
                  class="seller-img mr-3 mb-2 mb-md-0"
                  alt="Seller Logo"
                  fluid
                />
              </template>
              <p class="provideName mb-2">{{ providerName }}</p>
            </div>

            <div class="seller-address d-flex align-items-start mb-1">
              <b-icon icon="geo-alt-fill" class="address-icon"></b-icon>
              <div class="ml-2">
                <p class="mb-0">
                  {{
                    sellerInfo?.office?.address
                      ? `${sellerInfo.office.address.street1}, ${sellerInfo.office.address.city}, ${sellerInfo.office.address.state} - ${sellerInfo.office.address.zip}`
                      : ""
                  }}
                </p>
              </div>
            </div>

            <div class="infoNeedHelp mt-0">
              <div class="d-flex align-items-center mb-1">
                <b-icon icon="envelope-fill"></b-icon>
                <p class="ml-2 mb-0 text-break">{{ sellerMail }}</p>
              </div>
              <div class="d-flex align-items-center">
                <b-icon icon="telephone-forward-fill"></b-icon>
                <p class="ml-2 mb-0 text-break">{{ sellerPhone }}</p>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "need-help",
  data() {
    return {
      isLoading: false,
      orderNumber: "",
    };
  },
  computed: {
    ...mapState({
      orderDetailsData: (state) => state.profile.orderDetailsData,
      sellerInfo: (state) => state.profile.sellerInfo,
    }),
    providerName() {
      const name = Array.from(
        new Set(this.orderDetailsData.items?.map((each) => each.providerName))
      );
      return name[0] || "";
    },
    sellerMail() {
      const mail = Array.from(
        new Set(this.sellerInfo.office?.email.map((each) => each.mailId))
      );
      return mail[0] || "";
    },
    sellerPhone() {
      const number = Array.from(
        new Set(this.sellerInfo.office?.phone.map((each) => each.number))
      );
      return number[0] || "";
    },
  },
  methods: {},
  async mounted() {
    this.orderNumber = this.$route.params.orderId;
    await this.$store.dispatch(
      "profile/fetchSellerDetails",
      this.orderDetailsData.provider._id
    );
  },
};
</script>

<style scoped>
.bi-arrow-left-short {
  height: 3rem;
  width: 3rem;
  color: var(--primarycolor);
  padding: 0px;
}

.bi-arrow-left-short:hover {
  color: var(--darkcolor);
}
.need-help-wrapper {
  padding: 1rem;
}

@media (max-width: 767.98px) {
  .need-help-wrapper {
    margin: 0 !important;
    padding: 0.5rem;
  }
}

.seller-details-container {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  /* gap: 1rem; */
}

.seller-main-info {
  gap: 1rem;
}

.seller-img {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #eee;
}

.provideName {
  font-size: 1.25rem;
  font-weight: 600;
  word-break: break-word;
}

.address-icon {
  margin-top: 4px;
  /* color: #fd7e14; */
  flex-shrink: 0;
}

.infoNeedHelp {
  padding-left: 0;
}

@media (max-width: 767.98px) {
  .seller-details-container {
    padding: 1rem 0.5rem;
    gap: 0.75rem;
  }
  .seller-main-info {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 0.5rem;
  }
  .seller-img {
    margin-bottom: 0.5rem;
  }
  .seller-address {
    flex-direction: row;
    align-items: flex-start;
    /* gap: 0.5rem; */
  }
  .infoNeedHelp {
    margin-top: 1rem;
    padding-left: 0;
  }
}

.text-break {
  word-break: break-all;
}

/* .router-link-exact-active {
  color: #fd7e14;
}
.router-link-exact-active:hover {
  color: #fd7e14;
} */
.list-group-item {
  color: #495057;
}

.list-group-item:hover {
  background: #f8f9fa;
  text-decoration: none;
  color: #495057;
  cursor: pointer;
}

.profile-maindv {
  background: #f8f8f8;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #d6d6d6;
  position: relative;
  gap: 10px;
}
</style>
